import { endAuth0Session } from "../core";
import { useAuth } from "./useAuth";

/** Signs out to the app's root URL; `undefined` when nobody is signed in. */
export function useSignOut(): (() => void) | undefined {
  const { isEnabled, isAuthenticated, logout } = useAuth();
  if (!isEnabled || !isAuthenticated) return undefined;
  return () => endAuth0Session(logout);
}
